import React from 'react';

import PropTypes from 'prop-types';

import AppWrapper from 'components/apps/AppWrapper';
import { ProjectCoshhContext } from 'components/contexts/ProjectCoshhContext';
import MasterCoshhIndex from 'components/masterCoshh/components/MasterCoshhIndex';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <AppWrapper {...contextProps}>
      <ProjectCoshhContext.Provider value={{ ...wrappedProps }}>
        <MasterCoshhIndex />
      </ProjectCoshhContext.Provider>
    </AppWrapper>
  );
}

EntryPoint.propTypes = {
  wrappedProps: PropTypes.shape({
    comparisonValueForCustomValueUsage: PropTypes.string.isRequired,
    coshhDocumentPolicy: PropTypes.shape({
      canCreate: PropTypes.bool.isRequired,
      canDestroy: PropTypes.bool.isRequired,
      canUpdate: PropTypes.bool.isRequired,
    }).isRequired,
    personsAtRiskOptions: PropTypes.array.isRequired,
    projectId: PropTypes.string.isRequired,
    secondaryFieldPlaceholder: PropTypes.string.isRequired,
  }).isRequired,
};
